module.exports = __webpack_public_path__ + "img/cpu.83ddaa8c.svg";